export namespace UserUtils {
    /**
     * Gets initials from a user object
     * @param
     * @param toUppercase
     */
    export const getUserInitials = (
        { username, firstName, lastName, email }: IUser | ICurrentUser,
        toUppercase?: boolean,
    ) => {
        let initials: string;
        if (firstName?.length === 0 && lastName?.length === 0) initials = username.substring(0, 2);
        else initials = `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`.trim();
        if (toUppercase) initials = initials.toUpperCase();

        if (initials.trim().length === 0) {
            const localPart = (email ?? '').split('@')[0] ?? '';
            // Build two-letter initials from the email's local-part.
            // Prefer first letters from alphanumeric segments split by non-letters (e.g., '.', '-', '_').
            const cleanedForSegments = localPart.replace(/[^A-Za-z]+/g, ' ').trim();
            const segments = cleanedForSegments.split(/\s+/).filter(Boolean);

            let emailInitials = '';
            if (segments.length >= 2) {
                emailInitials = `${segments[0][0] ?? ''}${segments[1][0] ?? ''}`;
            } else {
                // Fallback: take the first two alphabetic characters ignoring separators
                emailInitials = localPart.replace(/[^A-Za-z]/g, '').substring(0, 2);
            }

            if (toUppercase) emailInitials = emailInitials.toUpperCase();
            initials = emailInitials;
        }

        return initials;
    };
}
